export enum FilePurpose {
  ACCOUNT_REQUIREMENT = 'account_requirement',
  ADDITIONAL_VERIFICATION = 'additional_verification',
  BUSINESS_ICON = 'business_icon',
  BUSINESS_LOGO = 'business_logo',
  CUSTOMER_SIGNATURE = 'customer_signature',
  DISPUTE_EVIDENCE = 'dispute_evidence',
  IDENTITY_DOCUMENT = 'identity_document',
  PCI_DOCUMENT = 'pci_document',
  TAX_DOCUMENT_USER_UPLOAD = 'tax_document_user_upload',
}
